export function formatParam<T> (params: T): string {
  if (!params) return ''
  let parameter = ''
  for (const key in params) {
    parameter += `${key}=${params[key]}&`
  }
  parameter = parameter.substr(0, parameter.length - 1)
  return parameter
}

// 解析日期
export function formatDate (number: number, format = 'Y-M-D h:m:s'): string {
  if (!number) return ''
  // 数据转化
  function formatNumber (n: number): string {
    const str = n.toString()
    return str[1] ? str : '0' + str
  }
  const formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
  const returnArr: any[] = []

  const date = new Date(number)

  returnArr.push(date.getFullYear())
  returnArr.push(formatNumber(date.getMonth() + 1))
  returnArr.push(formatNumber(date.getDate()))

  returnArr.push(formatNumber(date.getHours()))
  returnArr.push(formatNumber(date.getMinutes()))
  returnArr.push(formatNumber(date.getSeconds()))

  for (const i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i])
  }
  return format
}

/**
 * @param {number} opacity 透明度
 * @description: 16进制颜色加透明度 100 为不透明 0 为全透明
 * @return {string}
 * @example: HToOpacity(80) HToOpacity(20)
 */
export function HToOpacity (opacity: number): string {
  const obj: any = {
    '100%': 'FF',
    '99%': 'FC',
    '98%': 'FA',
    '97%': 'F7',
    '96%': 'F5',
    '95%': 'F2',
    '94%': 'F0',
    '93%': 'ED',
    '92%': 'EB',
    '91%': 'E8',
    '90%': 'E6',
    '89%': 'E3',
    '88%': 'E0',
    '87%': 'DE',
    '86%': 'DB',
    '85%': 'D9',
    '84%': 'D6',
    '83%': 'D4',
    '82%': 'D1',
    '81%': 'CF',
    '80%': 'CC',
    '79%': 'C9',
    '78%': 'C7',
    '77%': 'C4',
    '76%': 'C2',
    '75%': 'BF',
    '74%': 'BD',
    '73%': 'BA',
    '72%': 'B8',
    '71%': 'B5',
    '70%': 'B3',
    '69%': 'B0',
    '68%': 'AD',
    '67%': 'AB',
    '66%': 'A8',
    '65%': 'A6',
    '64%': 'A3',
    '63%': 'A1',
    '62%': '9E',
    '61%': '9C',
    '60%': '99',
    '59%': '96',
    '58%': '94',
    '57%': '91',
    '56%': '8F',
    '55%': '8C',
    '54%': '8A',
    '53%': '87',
    '52%': '85',
    '51%': '82',
    '50%': '80',
    '49%': '7D',
    '48%': '7A',
    '47%': '78',
    '46%': '75',
    '45%': '73',
    '44%': '70',
    '43%': '6E',
    '42%': '6B',
    '41%': '69',
    '40%': '66',
    '39%': '63',
    '38%': '61',
    '37%': '5E',
    '36%': '5C',
    '35%': '59',
    '34%': '57',
    '33%': '54',
    '32%': '52',
    '31%': '4F',
    '30%': '4D',
    '29%': '4A',
    '28%': '47',
    '27%': '45',
    '26%': '42',
    '25%': '40',
    '24%': '3D',
    '23%': '3B',
    '22%': '38',
    '21%': '36',
    '20%': '33',
    '19%': '30',
    '18%': '2E',
    '17%': '2B',
    '16%': '29',
    '15%': '26',
    '14%': '24',
    '13%': '21',
    '12%': '1F',
    '11%': '1C',
    '10%': '1A',
    '9%': '17',
    '8%': '14',
    '7%': '12',
    '6%': '0F',
    '5%': '0D',
    '4%': '0A',
    '3%': '08',
    '2%': '05',
    '1%': '03',
    '0%': '00'
  }
  const o = opacity + '%'
  return obj[o]
}

/**
 * @param {number} timestamp 时间戳
 * @description: 判断当前时间戳是否是今天 昨天 以及更早
 * @return {number} 0 今天 -1 昨天 -2 更早
 */
export function GetDateTY (timestamp: number): number | undefined {
  const d = Date.parse(new Date().toLocaleDateString())
  const t = Date.parse(new Date(timestamp).toLocaleDateString())
  if (d === t) {
    return 0
  } else if (d - t <= 86400000) { // 86400000 一天的毫秒数
    return -1
  } else if (d - t > 86400000) {
    return -2
  }
  console.error('方法：GetDateTY只能返回 今天: 0  昨天: -1  或  更早: -2')
}

/**
 * @param {array} arr 数组
 * @param {number} key 键
 * @description: 此方法只能删除简单数据类型的数组 如： [1,2,3,4] 或 [1,2,3,'2','4']
 * @return {number} arr
 * @example: ArrayRemove([1,2,3,4], 2) ArrayRemove([1,2,3,4], '2')
 */
export function ArrayRemove (arr: Array<any>, key: number | string): Array<any> {
  const a = JSON.parse(JSON.stringify(arr))
  let index = 0
  for (let i = 0; i < a.length; i++) {
    if (a[i] === key) {
      index = i
      break
    }
  }
  // const a = a.splice(index, 1)
  return a.splice(index, 1)
}

/**
 * @param {string} url http资源请求路径
 * @description: 拼接https请求的图片，解决谷歌浏览器在https环境下请求的http所有请求变成https，目前前端没有想到什么好的解决办法。
 * @return {string}
 * @example: httpsImg('http://***.***.com/**.png')
 */
export function httpsImg (url: string) : string {
  if (/^https/.test(url)) return url
  let urlPath = ''
  if (process.env.NODE_ENV === 'development') {
    urlPath = 'https://live-cast-app-stag.zowoyoo.com/openapi/common/getImageForUrl?url='
  } else {
    urlPath = 'https://live-cast-app.zowoyoo.com/openapi/common/getImageForUrl?url='
  }
  return urlPath + encodeURIComponent(url)
}

/**
 * 分割数组
 * @param {Array} arr  数组
 * @param {number} size  每份的分割数
 * @return {Array}
 */
export function splitArr (arr: Array<any>, size: number): Array<any> {
  const tempArr: any[] = []
  for (let i = 0; i < arr.length; i += size) {
    tempArr.push(arr.slice(i, i + size))
  }
  return tempArr
}

/**
 * @param {string} str
 * @description: 字符串加密 -- 1 2 调换
 * @return {string}
 * @example: Encryption(123)
 */
export function Encryption (str: string | number): string {
  str = String(str)
  str = window.btoa(str)
  const a:string[] = []
  const b:string[] = []
  for (let i = 0; i < str.length; i++) {
    if (i % 2 === 0) {
      a.push(str[i])
    } else {
      b.push(str[i])
    }
  }
  const num = a.length > b.length ? a.length : b.length
  const arr:string[] = []
  for (let j = 0; j < num; j++) {
    arr.push(b[j])
    arr.push(a[j])
  }
  const result = arr.join('')
  return result
}

/**
 * @param {string} str
 * @description: 字符串解密 1 2 调换
 * @return {string}
 * @example: Decode('TMzI')
 */
export function Decode (str: string | number): string {
  str = String(str)
  const a:string[] = []
  const b:string[] = []
  for (let i = 0; i < str.length; i++) {
    if (i % 2 === 0) {
      a.push(str[i])
    } else {
      b.push(str[i])
    }
  }
  const num = a.length > b.length ? a.length : b.length
  const arr:string[] = []
  for (let j = 0; j < num; j++) {
    arr.push(b[j])
    arr.push(a[j])
  }
  const result = arr.join('')
  return window.atob(result)
}

/**
 * @param {string} url 可传，默认拿 window.location.search
 * @description: 解析URL参数 返回一个对象
 * @return {object}
 * @example: 示例
 */
export function urlParse (url = window.location.search): {[key: string] : any} {
  // let url = window.location.search
  const obj = {}
  const reg = /[?&][^?&]+=[^?&]+/g
  const arr = url.match(reg)
  // ['?id=12345','&a=b']
  if (arr) {
    arr.forEach((item) => {
      const tempArr = item.substr(1).split('=')
      const key = decodeURIComponent(tempArr[0])
      const val = decodeURIComponent(tempArr[1])
      obj[key] = val
    })
  }
  return obj
}

// 处理计算结果的精度问题
export function CalculationnNum (n: number) {
  const num = Math.round(n * 100)
  return num / 100
}

// 下载文件
export function downloadFile (url: string, fileName?: string): void {
  const a = document.createElement('a')
  a.href = url
  a.download = fileName || new Date().getTime().toString()
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
